import React, { useState } from 'react';
import { useForm, SubmitHandler, FieldValues } from 'react-hook-form';
import { Partner, PartnerUpdate } from '@marageti/z4-sdk/lib/travel/Partner';
import { useParams } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { useSnackbar } from 'notistack';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { ContainerProps } from './types';
import EditPartnerDetailFormView from './edit-partner-detail-form-view';

const EditPartnerDetailFormContainer = ({
  open,
  onClose,
  partnerDetail,
}: ContainerProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const { partnerId } = useParams();
  const apiClient = useApiClient();
  const { enqueueSnackbar } = useSnackbar();
  const [submissionError, setSubmissionError] = useState<ApiError>();
  const { data: partner, mutate: mutatePartner } = useFetch<Partner>(apiClient.partnersClient.getPartner, [partnerId], !!partnerId);

  const handleCancel = () => {
    reset();
    onClose();
  };

  const onSubmit: SubmitHandler<FieldValues> = async (data) => {
    if (!partner) {
      return;
    }

    const updatedPartner: PartnerUpdate = {
      ...partner,
      ...data,
    };
    try {
      await apiClient.partnersClient.putPartner(partner.id, updatedPartner);
      mutatePartner();
      enqueueSnackbar(`${partnerDetail.displayName} updated.`, { variant: 'success' });
      onClose();
    } catch (error) {
      setSubmissionError(error as ApiError);
      enqueueSnackbar('An error occurred during the update.', { variant: 'default' });
    }
  };

  return (
    <EditPartnerDetailFormView
      errors={errors}
      handleSubmit={handleSubmit}
      onCancel={handleCancel}
      onSubmit={onSubmit}
      open={open}
      control={control}
      submissionError={submissionError}
      partner={partner}
      partnerDetail={partnerDetail}
    />
  );
};

export default EditPartnerDetailFormContainer;
